// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IntegrationInsuranceSelect_IntegrationInsuranceFragment = { __typename?: 'IntegrationInsurance', id: string, integrationID: string, name: string, externalKind: Types.IntegrationInsuranceExternalKind, value?: CurrencyUSD | null, cashValue?: CurrencyUSD | null, ownerName?: string | null, policyHolderName?: string | null, policyNumber?: string | null, policyType?: string | null, premiumAmount?: CurrencyUSD | null, startDate?: Time | null, termDurationYears?: number | null, integrationClient?: { __typename?: 'IntegrationClient', id: string, name: string } | null };

export type GetIntegrationInsurancesQueryVariables = Types.Exact<{
  optionsLike?: Types.InputMaybe<Types.IntegrationInsuranceWhereInput>;
  selectedOptionsLike?: Types.InputMaybe<Types.IntegrationInsuranceWhereInput>;
  first: Types.Scalars['Int']['input'];
}>;


export type GetIntegrationInsurancesQuery = { __typename?: 'Query', queryData: { __typename?: 'IntegrationInsuranceConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationInsuranceEdge', node?: (
        { __typename?: 'IntegrationInsurance' }
        & IntegrationInsuranceSelect_IntegrationInsuranceFragment
      ) | null } | null> | null }, selectedData: { __typename?: 'IntegrationInsuranceConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationInsuranceEdge', node?: (
        { __typename?: 'IntegrationInsurance' }
        & IntegrationInsuranceSelect_IntegrationInsuranceFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetIntegrationInsurances: 'GetIntegrationInsurances' as const
  },
  Fragment: {
    IntegrationInsuranceSelect_IntegrationInsurance: 'IntegrationInsuranceSelect_IntegrationInsurance' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const IntegrationInsuranceSelect_IntegrationInsuranceFragmentDoc = gql`
    fragment IntegrationInsuranceSelect_IntegrationInsurance on IntegrationInsurance {
  id
  integrationID
  name
  externalKind
  value
  cashValue
  ownerName
  policyHolderName
  policyNumber
  policyType
  premiumAmount
  startDate
  termDurationYears
  integrationClient {
    id
    name
  }
}
    `;
export const GetIntegrationInsurancesDocument = gql`
    query GetIntegrationInsurances($optionsLike: IntegrationInsuranceWhereInput, $selectedOptionsLike: IntegrationInsuranceWhereInput, $first: Int!) {
  queryData: integrationInsurances(where: $optionsLike, first: $first) {
    totalCount
    edges {
      node {
        ...IntegrationInsuranceSelect_IntegrationInsurance
      }
    }
  }
  selectedData: integrationInsurances(where: $selectedOptionsLike) {
    totalCount
    edges {
      node {
        ...IntegrationInsuranceSelect_IntegrationInsurance
      }
    }
  }
}
    ${IntegrationInsuranceSelect_IntegrationInsuranceFragmentDoc}`;

/**
 * __useGetIntegrationInsurancesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationInsurancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationInsurancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationInsurancesQuery({
 *   variables: {
 *      optionsLike: // value for 'optionsLike'
 *      selectedOptionsLike: // value for 'selectedOptionsLike'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetIntegrationInsurancesQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationInsurancesQuery, GetIntegrationInsurancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationInsurancesQuery, GetIntegrationInsurancesQueryVariables>(GetIntegrationInsurancesDocument, withFetchPolicyContext(options));
      }
export function useGetIntegrationInsurancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationInsurancesQuery, GetIntegrationInsurancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationInsurancesQuery, GetIntegrationInsurancesQueryVariables>(GetIntegrationInsurancesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetIntegrationInsurancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationInsurancesQuery, GetIntegrationInsurancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationInsurancesQuery, GetIntegrationInsurancesQueryVariables>(GetIntegrationInsurancesDocument, withFetchPolicyContext(options));
        }
export type GetIntegrationInsurancesQueryHookResult = ReturnType<typeof useGetIntegrationInsurancesQuery>;
export type GetIntegrationInsurancesLazyQueryHookResult = ReturnType<typeof useGetIntegrationInsurancesLazyQuery>;
export type GetIntegrationInsurancesSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationInsurancesSuspenseQuery>;
export type GetIntegrationInsurancesQueryResult = Apollo.QueryResult<GetIntegrationInsurancesQuery, GetIntegrationInsurancesQueryVariables>;